import styled from 'styled-components'
export const MyContainer = styled.div`
    width: 980px;
    margin: 0 auto;

    @media screen and (max-width: 1023px) {
        width: 728px;
    }

    @media screen and (max-width: 767px) {
        width: 100%;
        padding: 0 12px;
    }
`;